import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import {AGREEMENT_STATUS_AGREEMENT} from '@/util'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'menu',
    component: () => import('@/views/pages/Top/Menu.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/pages/Login/Login.vue'),
    meta: {notAuth: true, layout: 'login'}
  },
  // 他社比較分析
  {
    path: '/comparison/store',
    name: 'comparison.store',
    component: () => import('@/views/pages/Store/Detail.vue'),
    meta: {layout: 'comparison', report: 'web'},
  },
  {
    path: '/comparison/base',
    name: 'comparison.base',
    component: () => import('@/views/pages/Comparison/UserBase/Edit.vue'),
    meta: {layout: 'comparison', report: 'web'},
    props: true
  },
  {
    path: '/comparison/graph',
    name: 'comparison.graph',
    component: () => import('@/views/pages/Comparison/Graph.vue'),
    meta: {layout: 'comparison', report: 'web'},
    props: true
  },
  {
    path: '/comparison/summary',
    name: 'comparison.summary',
    component: () => import('@/views/pages/Comparison/Summary.vue'),
    meta: {layout: 'comparison', report: 'web'},
    props: true
  },
  // 自社分析
  {
    path: '/demand/store',
    name: 'demand.store',
    component: () => import('@/views/pages/Demand/Store.vue'),
    meta: {layout: 'demand', report: 'demand'},
  },
  {
    path: '/demand/visitor',
    name: 'demand.visitor',
    component: () => import('@/views/pages/Demand/VisitorForecast.vue'),
    meta: {layout: 'demand', report: 'demand'},
  },

  // not found
  {path: '*', component: () => import('@/views/pages/Top/Menu.vue')},
]

const router = new VueRouter({
  mode: 'history',
  scrollBehavior() {
    return {x: 0, y: 0}
  },
  base: process.env.BASE_URL,
  routes
})

// ログインしていなかったらログインページにリダイレクト
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.notAuth)) {
    // 未ログインOK
    next();
  } else {
    // 上記以外の場合
    if (store.getters['auth/check'] === false) {
      // ログインしていない場合
      next({
        path: '/login',
        query: {redirect: to.fullPath}
      });
    } else {
      // 上記以外の場合
      // ログインアカウントの契約情報を参照して、契約中ではないならメニューへリダイレクト
      // (契約状況に関係ない画面は無条件で指定ページへ)
      if (to.matched.some((record) => {
        return checkAgreementStatus(record)
      })) {
        next()
      } else {
        next({
          path: '/',
        });
      }
    }
  }

  /**
   * 契約状態チェック
   * @param {*} record
   * @returns Boolean true:契約中（遷移OK）/false:未契約（遷移NG）
   */
  function checkAgreementStatus (record) {
    const report = record.meta.report
    if (report === 'web') {
      // web-reportの画面の場合、WEBレポートを契約中である
      return store.getters['auth/agreement_web_report'] === AGREEMENT_STATUS_AGREEMENT
    } else if (report === 'demand') {
      // demand-reportの画面の場合、需要予測を契約中である
      return store.getters['auth/agreement_demand_report'] === AGREEMENT_STATUS_AGREEMENT
    } else if (report !== undefined) {
      // reportが設定されていること
      return store.getters['auth/agreement_web_report'] === AGREEMENT_STATUS_AGREEMENT
          || store.getters['auth/agreement_demand_report'] === AGREEMENT_STATUS_AGREEMENT
    } else {
      // 上記以外、無条件でOK
      return true
    }
  }
});

export default router
